import NavigationLayout from "../navigation/navigationLayout";
import FooterLayout from "../footer/footerLayout";
import TitleComponent from '../../components/widgets/titleComponent';
import { useTranslation } from "react-i18next";
import { Box, Stack, useTheme } from "@mui/material";
import ButtonComponent from "../../components/form/buttonComponent";
import { useCallback, useState } from "react";
import DigitalStudioTabView from "./digitalStudioTabView";
import GetQuote from "../contactUs/getQuote";
import companyData from '../../assets/data/company.json';

const DigitalStudioLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const [openQuote, setOpenQuote] = useState(false);

    const getAQuote = useCallback(() => {
        // setOpenQuote(true);

        window.open(companyData.contact.formLinks.quotation, "_blank");
    }, []);

    return (
        <>
            <NavigationLayout />

            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pt: {xs: 15, md: 20, lg: 25}
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='start'
                    alignItems='center'
                    px='5%'
                >
                    <TitleComponent 
                        title={t('digitalStudio.title')}
                        description={t('digitalStudio.description')}
                        centerMode
                    />

                    <ButtonComponent 
                        label={t('digitalStudio.interested')}
                        onClick={getAQuote}
                        sx={{
                            animation: 'bounceButton 1s infinite',
                            mb: {xs: 3, md: 0}
                        }}
                    />

                    <DigitalStudioTabView />
                </Stack>
            </Box>

            <FooterLayout />

            <GetQuote open={openQuote} setOpen={setOpenQuote}/>
        </>
    );
}

export default DigitalStudioLayout;